import { useCifraClient } from "../cifra-client";

const { cifraClient } = useCifraClient();

const URL_BASE = '/api_publica/v1/calificaciones/formulas';

export default {
  eliminar(idFormula, options) {
    const data = {
      id: idFormula,
    };
    return cifraClient.delete(`${URL_BASE}/${idFormula}`, { data }, options);
  },
};
